import React from "react";
import ModalComponent from "../Modal/Modal.tsx";
import Button from "../Button/Button.tsx";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext.tsx";
import * as S from "./sessionExpired.style.ts";

interface SessionExpiredProps {
  closeModal: (val: boolean) => void;
  isOpen: boolean;
}

const SessionExpired = ({ closeModal, isOpen }: SessionExpiredProps) => {
  const { logout } = useAuth();
  const navigate = useNavigate();

  const signIn = () => {
    closeModal(true);
    navigate("/");
  };

  const logOutAccount = () => {
    closeModal(true);
    logout();
  };

  return (
    <ModalComponent isOpen={isOpen} title={`Session Expired`}>
      <S.ModalWrapper>
        <span>Your session has expired. Please sign in again to continue.</span>
        <S.ModalBtn>
          <Button
            buttonSize="small"
            handleClick={logOutAccount}
            classType="register"
          >
            Stay Logged Out
          </Button>
          <Button buttonSize="small" handleClick={signIn}>
            Sign In
          </Button>
        </S.ModalBtn>
      </S.ModalWrapper>
    </ModalComponent>
  );
};

export default SessionExpired;
